/**
 * Form Permission Constants for the Forms MVP feature.
 *
 * These names mirror the rows inserted by the Prisma migration
 * `20260420120000_form_permissions` into the legacy `permissions` table.
 *
 * `PermissionControl` / `isPermitted` compare permission names with
 * `.toLowerCase()`, so the string values here must match the DB rows
 * exactly (lowercase, underscore-separated).
 */

// Forms list visibility, CSV export, submissions, and previews.
export const FORM_VIEW = 'form_view';

// Case-plan Forms widgets check this list. Read access is `form_view`.
export const FORM_READ_PERMISSIONS = [FORM_VIEW];

// Authoring a new form in the Forms tab (Create New Form button, /forms route).
export const FORM_CREATE = 'form_create';

// Editing, enabling/disabling, and deleting forms.
export const FORM_MANAGE = 'form_manage';

// Attaching an existing form to an announcement or message from the composer.
export const FORM_ATTACH = 'form_attach';
